import { useCallback } from 'react'

import StripeHelpers from 'helpers/stripe_helpers'
import { useBookeePaymentCapabilitiesSelector } from 'store/selectors'

export const getPaymentMethodDisabled = (paymentMethod, supportedPaymentMethodTypes = [StripeHelpers.capabilities.card]) => {
  const paymentMethodType = paymentMethod?.data?.type

  if (!supportedPaymentMethodTypes || !Array.isArray(supportedPaymentMethodTypes)) return false
  if (!paymentMethodType) return false

  return !supportedPaymentMethodTypes.includes(paymentMethodType)
}

const useGetPMDisabled = () => {
  const bookeePaymentCapabilities = useBookeePaymentCapabilitiesSelector()
  const supportedPaymentMethodTypes = bookeePaymentCapabilities?.supported_payment_method_types

  return useCallback((pm) => getPaymentMethodDisabled(pm, supportedPaymentMethodTypes), [supportedPaymentMethodTypes])
}

export default useGetPMDisabled
